// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "contentweb/static/styles/" + "mntv-app-contentweb" + "." + "d886efaf" + ".css";
};